import React from 'react'
import PropTypes from 'prop-types'
import { StyledH4 } from './atoms'

export const AutoPayment = ({
  is_variable_amount,
  max_payment_amount,
  payment_amount,
}) => {
  return (
    <StyledH4>
      <strong>
        {is_variable_amount && max_payment_amount
          ? __('Total Balance')
          : (payment_amount && i18nUtils.currency(payment_amount)) ||
            __('Total Balance')}
      </strong>
    </StyledH4>
  )
}

export const Split = ({ is_approved }) => (
  <StyledH4>
    {!is_approved && __('Proposed')} {__('Split Payment')}
  </StyledH4>
)
export const BiMonthly = () => <StyledH4>{__('Bi-Monthly Payment')}</StyledH4>

AutoPayment.propTypes = {
  is_variable_amount: PropTypes.bool,
  max_payment_amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  payment_amount: PropTypes.number,
}

Split.propTypes = {
  is_approved: PropTypes.bool,
}
